import { render, staticRenderFns } from "./ContainerTruckKH.vue?vue&type=template&id=88b20a80"
import script from "./ContainerTruckKH.vue?vue&type=script&lang=js"
export * from "./ContainerTruckKH.vue?vue&type=script&lang=js"
import style0 from "./ContainerTruckKH.vue?vue&type=style&index=0&id=88b20a80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports